import { ReactNode, useState } from "react";

import LoadStatusProvider from "common/load/LoadStatusProvider";

import ConfirmationDialog from "../components/content/ConfirmationDialog";
import Dialog from "../components/stackables/Dialog";

type ReloadRequiredDialogProps = {
  isVisible: boolean;
};

const ReloadRequiredDialog = ({ isVisible }: ReloadRequiredDialogProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const performReload = () => {
    setIsLoading(true);
    if (!isLoading) {
      window.location.reload();
    }
  };
  return (
    <Dialog.Standalone isVisible={isVisible} onClose={performReload}>
      <ConfirmationDialog
        title="Your session has expired"
        description="Please refresh the page and try again."
        confirmText="Refresh Page"
        onDeny={performReload}
        onConfirm={performReload}
        hasDenyButton={false}
      />
    </Dialog.Standalone>
  );
};

type ClientLoadStatusProviderProps = {
  children: ReactNode;
};

const ClientLoadStatusProvider = ({ children }: ClientLoadStatusProviderProps) => {
  return (
    <LoadStatusProvider renderReloadRequiredOverlay={(p) => <ReloadRequiredDialog {...p} />}>
      {children}
    </LoadStatusProvider>
  );
};

export default ClientLoadStatusProvider;
